<section class="banner-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="banner-title">
                    <div class="title"><h1>온라인 무료 구두점 검사기</h1></div>
                    <p>AI로 구동되는 트링카의 무료 구두점 검사기로 구두점 오류를 즉시 수정해 보세요.<br/>트링카 AI는 구두점 실수를 찾아내고 수정하여 글을 개선함으로써 자신 있는 문서 작성을 도와드립니다.</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-english-grammar-checker></app-english-grammar-checker>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>


<div class="gcBrowserSection">
    <div class="container">
        <div class="row">
            <div class="gcBrowserContainer">
                <h2>어디에서나 완벽한 글을 작성 할 수 있는 문법 및 구두점 검사기!</h2>
                <a  id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"><img src="../../../assets/images/NewChromeIcon.svg" alt="chrome"> 크롬을 위한 설치</a>
                <a  id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank"><img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox">  또한 설치 가능</a>
                <a  id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"><img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge">  가장자리 위한 설치</a>
            
            </div>
        </div>
    </div>
</div>

<div class="signupmobile" style="display: none !important;">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinkaPluginGCSection">
                    <h2>무료 트링카 계정</h2>
                    <P>월 최대 5000단어까지 글을 검사해 언어와 스타일의 전반적 향상을 확인하고</P>
                    <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">지금 바로 가입하세요!</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka_demo_wrap" style="display: none !important;">
    <div class="see_trinka_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="top_heading howItWorkHeading lineWhiteColor">
                        <h3>온라인 무료 구두점 검사기</h3>
                        <div class="HeadingSubLine"></div>
                        <p>AI로 구동되는 트링카의 무료 구두점 검사기로 구두점 오류를 즉시 수정해 보세요.<br/>트링카 AI는 구두점 실수를 찾아내고 수정하여 글을 개선함으로써 자신 있는 문서 작성을 도와드립니다.</p>
                    </div>
                </div>
            </div>
            <div class="row match-box">
                <div class="col-lg-8 dflex">
                    <div class="editor_sections c-card" style="height:100%;">
                        <div class="gcLoaderSection" *ngIf="showloader">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: block;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                <circle cx="75" cy="50" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.9166666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.9166666666666666s"></animate>
                                </circle><circle cx="71.65063509461098" cy="62.5" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.8333333333333334s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.8333333333333334s"></animate>
                                </circle><circle cx="62.5" cy="71.65063509461096" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.75s"></animate>
                                </circle><circle cx="50" cy="75" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.6666666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.6666666666666666s"></animate>
                                </circle><circle cx="37.50000000000001" cy="71.65063509461098" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5833333333333334s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5833333333333334s"></animate>
                                </circle><circle cx="28.34936490538903" cy="62.5" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
                                </circle><circle cx="25" cy="50" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.4166666666666667s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.4166666666666667s"></animate>
                                </circle><circle cx="28.34936490538903" cy="37.50000000000001" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.3333333333333333s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.3333333333333333s"></animate>
                                </circle><circle cx="37.499999999999986" cy="28.349364905389038" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.25s"></animate>
                                </circle><circle cx="49.99999999999999" cy="25" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.16666666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.16666666666666666s"></animate>
                                </circle><circle cx="62.5" cy="28.349364905389034" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.08333333333333333s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.08333333333333333s"></animate>
                                </circle><circle cx="71.65063509461096" cy="37.499999999999986" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
                                </circle>
                            </svg>
                        </div>
                        <div style="display: none;" class="loading loader" #loading>&#8230;</div>
                        <div class="editor_top_section" [ngClass] = "(wordCount > maxLength) ? 'redWord' : '' ">
                            <!-- <span (click)="addDummyText()" class="dummy-text">Example text</span> -->
                            <span class="dorpdownText">
                                <button mat-button [matMenuTriggerFor]="sample" class="tryDemo_exampleText file_manager_dropdown">
                                    <!-- <img class="img-fluid" src="../../../../assets/images/UseExampleText.svg" alt="logo favicon"> -->
                                    <span>예제 텍스트<i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                </button>
                                <mat-menu #sample="matMenu" class="file_manager_sub_menus new_file_sections">
                                    <mat-radio-group aria-label="Select an option" (change)="addSampleData($event)" name="example">
                                        <ng-container *ngFor="let data of sampleData;index as i;">
                                            <mat-radio-button value="{{data.key}}">{{data.key}} </mat-radio-button><br>
                                        </ng-container>
                                    </mat-radio-group>
                                </mat-menu>
                            </span>
                            <span class="float-right word_count_section">단어: <b>{{wordCount}}/{{maxLength}}</b></span>
                        </div>

                        <!-- <div class="ck-editor" z>
                            <ck-editor name="editor1" [(ngModel)]="editorValue" [config]="config" language="en"
                                [fullPage]="false" (change)="onChange($event)" (blur)="onBlur($event)"
                                (focus)="onFocus($event)" (focusout)="outFocus($event)" (mouseup)="onMouseUp($event)"
                                (paste)="onPaste($event)" (keyup)="onKeyUp($event)" placeholder="Write your message">
                            </ck-editor>
                        </div> -->
                        <div class="ck-editor" style="height:280px; overflow: auto;">
                            <textarea #sampleEditor id ="sampleEditor" style="height: 100%;width: 100%;border: none;padding: 10px;outline: 0;display: block ;" (keyup)="onChange($event)" (paste)="onChange($event)" (change)="onChange($event)"></textarea>
                        </div>
                        <div class="Footer_button_section">
                            <div class="footer_radionButtons">
                                <div class="custom-control custom-radio d-inline">
                                    <input type="radio" class="custom-control-input" id="customControlValidation2"
                                        [checked]="languageSelection == 'us'" name="radio-stacked" value="us"
                                        name="style" (change)="languageTypeSelect('us')" required>
                                    <label class="custom-control-label mr-3"
                                        for="customControlValidation2">English-US</label>
                                </div>
                                <div class="custom-control custom-radio d-inline">
                                    <input type="radio" class="custom-control-input" id="customControlValidation3"
                                        [checked]="languageSelection == 'uk'" name="radio-stacked" value="uk"
                                        name="style" (change)="languageTypeSelect('uk')" required>
                                    <label class="custom-control-label"
                                        for="customControlValidation3">English-UK</label>
                                </div>
                            </div>
                            <div class="check_emailBox">
                                <!-- <input type="text" class="form-control" id="text-email" placeholder="Enter your email"
                                    [(ngModel)]="emailAdress"> -->
                                <button id="checkMyWritingButton" (click)="onGrammarCheck($event)" [disabled]="enableCheck || isProcessStarted"
                                    class="btn btn-primary">글 확인
                                    <div class="gcLoaderSection" *ngIf="isProcessStarted">
                                        <svg style="margin: auto; display: block;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: inline-block;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                            <circle cx="75" cy="50" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.9166666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.9166666666666666s"></animate>
                                            </circle><circle cx="71.65063509461098" cy="62.5" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.8333333333333334s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.8333333333333334s"></animate>
                                            </circle><circle cx="62.5" cy="71.65063509461096" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.75s"></animate>
                                            </circle><circle cx="50" cy="75" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.6666666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.6666666666666666s"></animate>
                                            </circle><circle cx="37.50000000000001" cy="71.65063509461098" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5833333333333334s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5833333333333334s"></animate>
                                            </circle><circle cx="28.34936490538903" cy="62.5" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
                                            </circle><circle cx="25" cy="50" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.4166666666666667s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.4166666666666667s"></animate>
                                            </circle><circle cx="28.34936490538903" cy="37.50000000000001" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.3333333333333333s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.3333333333333333s"></animate>
                                            </circle><circle cx="37.499999999999986" cy="28.349364905389038" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.25s"></animate>
                                            </circle><circle cx="49.99999999999999" cy="25" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.16666666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.16666666666666666s"></animate>
                                            </circle><circle cx="62.5" cy="28.349364905389034" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.08333333333333333s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.08333333333333333s"></animate>
                                            </circle><circle cx="71.65063509461096" cy="37.499999999999986" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
                                            </circle>
                                        </svg>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- <p class="myWriting_text">By clicking Check My Writing, you are agreeing to our <a
                            routerLink="/termsofservices/">Terms of Service</a> and <a
                            routerLink="/privacypolicy/">Privacy Policy</a>.</p> -->
                              
                </div>
                <div class="col-lg-4 dflex">
                    <div class="gcResultSection c-card">
                        <div class="trinkaPluginGCSection">
                            <h2>무료 트링카 계정</h2>
                            <P>월 최대 5000단어까지 글을 검사해 언어와 스타일의 전반적 향상을 확인하고</P>
                            <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">지금 바로 가입하세요!</a>
                            <h3>특징:</h3>
                            <ul>
                                <li>문법 및 철자 오류</li>
                                <li>단어 선택</li>
                                <li>언어 향상</li>
                                <li>글쓰기 조언</li>
                            </ul>
                        </div>
                        <!-- <div class="editor_options_with_cards" *ngIf="alertErrorMessage == 'TRUE' &&!gec_result.length">
                            <h2>The issues detected in your text will be displayed here.</h2>
                            <h3>Our robust correction algorithm checks your English text for</h3>
                            <ul>
                                <li>Grammar errors</li>
                                <li>Spelling mistakes</li>
                                <li>US–UK spellings</li>
                                <li>Word usage</li>
                                <li>Language enhancement</li>
                                <li>Writing advice</li>
                            </ul>
                        </div> -->
    
                        <h4 *ngIf="!noeErrorFound && alertErrorMessage != 'TRUE'"
                            class="align-content-center again_check_my_writing tempClass" [innerHTML]="alertErrorMessage">
                        </h4>
                        <h4 *ngIf="!gec_result.length && noeErrorFound && alertErrorMessage != 'TRUE'"
                            class="align-content-center again_check_my_writing tempClass" [innerHTML]="alertErrorMessage">
                        </h4>
    
                        <div *ngIf="gec_result.length" class="mt-0 font-14 issueCountLabel-wrap">
                            <span class="issueCountLabel"> Issues Found: <span class="errors-ctn">{{gec_result.length}}</span></span>
                        </div>
    
                        <div class="errorPanel" *ngIf="gec_result.length">
                            <mat-accordion>
                                <ng-container *ngFor="let item of gec_result ; let j = index">
                                    <mat-expansion-panel class="mat-expansion-panel-spacing mb-2 mt-0 error-type"
                                        *ngIf="!item.isCorrected" (opened)="setStep(item, j)" (closed)="setStepOff(item, j)"
                                        [ngClass]="injectErrorClass(item)" [expanded]="j === 0">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <ng-container *ngIf="!item.isExpanded">
    
                                                    <div>
                                                        <strong> {{item.covered_text}}</strong>
                                                    </div>
                                                    <span *ngIf="item.error_type[0] == 1">&nbsp;(Grammar)</span>
                                                    <span *ngIf="item.error_type[0] == 2">&nbsp;(Spelling)</span>
                                                    <span *ngIf="item.error_type[0] == 3">&nbsp;(Writing
                                                        Adviser)</span>
                                                    <span *ngIf="item.error_type[0] == 4">&nbsp;(Enhancement)</span>
                                                </ng-container>
    
                                                <div *ngIf="item.isExpanded">
                                                    <strong *ngIf="item.error_type[0] == 1">&nbsp;
                                                        Grammar</strong>
                                                    <strong *ngIf="item.error_type[0] == 2">&nbsp;
                                                        Spelling</strong>
                                                    <strong *ngIf="item.error_type[0] == 3">&nbsp; Writing
                                                        Adviser</strong>
                                                    <strong *ngIf="item.error_type[0] == 4">&nbsp;
                                                        Enhancement</strong>
                                                </div>
                                            </mat-panel-title>
                                            <mat-panel-description>
                                                <span (click)="rejectChange(item,j,false)">
                                                    <img src="assets/images/delete-icon.png" alt="icon">
                                                </span>
    
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div *ngFor="let output of item.output; let k = index" class="error-main">
                                            <div class="error-inner">
                                                <div
                                                    *ngIf="(item.output[k] == '' && item.error_type[k] == 3 || item.error_type[k] == 4) && !item.cta_present[k]">
                                                    <label> {{item.covered_text}}</label>
                                                </div>
                                                <div *ngIf="item.output[k] != '' && item.cta_present[k]">
                                                    <b><s>{{item.covered_text}}</s></b> <span class="arrow"><img
                                                            src="assets/images/arrow.png" alt="icon"></span>
                                                    <label class="error-link" (click)="error_panel_action(item,j,output)"
                                                        [ngClass]="injectErrorClass(item)">{{item.output[k]}}</label>
                                                </div>
    
                                                <div *ngIf="item.output[k] == '' && item.cta_present[k]">
                                                    <label class="error-link" (click)="error_panel_action(item,j,output)"
                                                        [ngClass]="injectErrorClass(item)">Delete
                                                        '<span>{{item.covered_text}}</span>'</label>
                                                </div>
                                            </div>
                                            <div class="error-comment">{{item.comment[k]}}</div>
                                            <hr>
                                        </div>
                                    </mat-expansion-panel>
                                </ng-container>
                            </mat-accordion>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>최고의 구두점 검사기 <small>(무료) </small></h2>
                    <div class="HeadingSubLine"></div>
                    <p>트링카의 구두점 검사기는 구두점의 올바른 사용을 체크하는 것은 물론 문법, 스타일, 어조의 복잡한 오류도 수정해 드립니다! </p>
                    <p>트링카는 전 분야에서 가장 잘 쓰여진 논문을 통해 학습하여 가장 적절한 제안을 제공해 드립니다. 트링카를 사용하면 언제나 정확한 글을 쓸 수 있습니다. </p>
                    <div class="most_suited_point">
                        <ul>
                            <li>구두점 검사로 시간 절약</li>
                            <li>무료로 즐기는 검사</li>
                            <li>글쓰기 전문화</li>
                            <li>고품질 데이터 보안</li>
                        </ul>
                    </div>
                    <p>트링카의 온라인 구두점 검사기는 쉼표, 하이픈, 세미콜론 및 기타 문장부호의 오류를 감지하고 더 나은 이해를 위한 설명과 함께 개선 제안을 제공해 드립니다.</p>
                    <p>무료로 더 많은 기능을 사용하려면 지금 가입하세요!</p>
                    <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank" class="cta-btn"> 시작하기 </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckSection">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-4">
                <div class="grammarCheckHeadingSection">
                    <h2>사용자 추천</h2>
                </div>
            </div>
            <div class="col-md-8">
                <div class="grammarCheckTextContent">
                    <p>트링카는 영어 작문 능력을 향상시키고자 하는 모든 사람에게 이상적입니다. 트링카의 무료 구두점 검사 도구는 학계 전문가, 카피라이터, <br class="d-lg-block d-none"/> 마케팅 담당자, 콘텐츠 작가, 제품 담당 팀, 블로거, 자가 출판 작가를 <br class="d-lg-block d-none"/> 비롯한 많은 사람들의 신뢰를 받고 있습니다.</p>
                </div>
            </div>
        </div> 
    </div>
</div>

<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>트링카 구두점 검사기의 주요 기능</h2>
                    <div class="HeadingSubLine"></div>
                    <!-- <p>Enhance and check your writing instantly with the best English grammar checker. Trinka's advanced
                        checking feature highlights mistakes and provides contextual suggestions that make your writing
                        rise and shine.</p> -->
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>완벽한 구두점 검사</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>트링카는 문맥에 적합한 구두점 검사를 제공하여 글을 향상시켜 드립니다.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Technical word choice</h4> -->
                            <p>In this economic recession, the Japanese economy managed to bounce back from the recession <span class="wrong_text">quickly,</span>&nbsp;<span class="right_text"> quickly</span> and achieved relatively good results.</p>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>다양한 주제 분야  </h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>트링카는 사용자의 주제 영역을 기반으로 하여 가장 적절한 구두점을 제안해 드립니다.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Syntax</h4> -->
                            <p>Therefore, it is shaped like a column if the agents have the most <span class="wrong_text">risk prone</span>&nbsp;<span class="right_text"> risk-prone</span> attitude.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>단어 선택</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>구두점 검사에 더하여, 트링카는 문법 및 단어 선택 오류를 수정하여 글의 정확도와 명확성을 높여드립니다. 트링카를 사용하여 글의 의도를 정확하게 전달하세요.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Advance Spelling</h4> -->
                            <p>One of the reasons is <span class="wrong_text">because</span> <span
                                class="right_text"> that</span> the fabrication cost <span
                                class="wrong_text">for</span> <span class="right_text"> of</span> steel
                            members depends upon the material.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>어드밴스 철자 체크</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>구두점 오류 수정 외에도 트링카의 무료 철자 검사기는 글의 문맥을 검사하여 해당 주제에 적합한 단어를 선택하도록 도움을 드립니다. 어색한 오타는 이제 안녕입니다! </p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Sensitive language</h4> -->
                            <p>The <span class="wrong_text">Bonferoni</span> <span
                                class="right_text"> Bonferroni</span> test was used to check for
                            statistical significance.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="use_trinka_other_app">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="use_trinka_content">
                    <div class="use_trinka_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>사용 가능한 플랫폼</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="cloud">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/wordplugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/wordAdd_in.svg" alt="word">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewChromeIcon.svg" alt="chrome">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <span class="safariComingSoonTag">Coming Soon</span>
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/safari_logo.png" alt="safari">
                                        <h3>Safari</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="moreEffectiveSection">
    <div class="container">
        <div class="row flex-row-reverse align-items-center">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>트링카의 무료 구두점 검사기는 어떻게 <br class="d-lg-block d-none" /> 작동하나요?</h2>
                    <p>트링카는 AI 기반 무료 구두점 검사기이자 언어 쓰기 보조 도구로 학술 및 기술 글쓰기 향상을 위해 설계되었습니다.</p>
                    <p>문장의 맥락을 기반으로 하여 최신 기계학습(ML) 및 자연어(NPL) 기술을 통해 개발된 트링카 구두점 검사기는 쉼표, 하이픈, 아포스트로피, 세미콜론, 기타 구두점의 오류를 쉽게 식별하고 명확성과 가독성을 높여줄 개선 사항을 제안해 드립니다.</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="../../../assets/images/WritingMoreEffective.png" alt="writing">
                </div>
            </div>
            
        </div>
        <div class="row colunmChangesSection align-items-center">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>트링카 구두점 검사 사용법</h2>
                    <p>모든 구두점 교정은 학습의 기회입니다. 트링카의 구두점 검사기는 오류를 강조 표시하는 것은 물론 오류를 수정하는 방법과 관련 설명도 제공하여 더 나은 글을 쓰도록 도와드립니다. 구두점 검사와 더불어, 트링카는 문법 및 언어 오류도 체크하여 전반적인 글쓰기 품질에 대한 지표 점수를 제공해 드립니다.</p>
                    <p>트링카 구두점 검사기를 통해 학생들은 효과적으로 글을 쓰는 방법을 배우고 글쓰기 모범 사례를 익힐 수 있습니다.</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="../../../assets/images/LearnGrammarwithTrinka.png" alt="learn">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="testimonail_demo_page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonail_heading">
                    <h2>Testimonials</h2>
                    <p>Check what users are saying about Trinka</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="users">
                    </div>
                    <p>The grammar checking tool exceeds Grammarly! I re-checked some documents that I had checked
                        earlier with Grammarly. I was pleasantly surprised to see such a product from India!</p>
                    <div class="testimonals_footer">
                        <p>Radiologist, India</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="users">
                    </div>
                    <p>First, I love Trinka. Congratulations on developing something that extensively aids editing,
                        especially critical grammar conventions and word count reductions.</p>
                    <div class="testimonals_footer">
                        <p>Academic Editor, USA</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="users">
                    </div>
                    <p>I have tested Trinka and am impressed with its fine capabilities. It did better than the grammar
                        checker I use. Well done! I have told my colleagues in my research lab to use Trinka. Hope it is
                        widely used in academia.</p>
                    <div class="testimonals_footer">
                        <p>PhD Scholar, UK</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<section class="section-md gc-testimonials-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center testi">
                <div class="GCTestmonials">
                    <h2>고객 사용 후기</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
            </div>
        </div>
    </div>
    <div class="testimonial text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="testimonial-wrap">
                        <!-- <div class="testimonal-icon">
                            <img src="../../../assets/images/testimonial.png" alt="grammar-checker-testimonial">
                        </div> -->
                        <div class="testimonial-slider">
                            <div id="testi" class="carousel slide" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#testi" data-slide-to="0" class="active"></li>
                                    <li data-target="#testi" data-slide-to="1"></li>
                                    <li data-target="#testi" data-slide-to="2"></li>
                                    <li data-target="#testi" data-slide-to="3"></li>
                                    <li data-target="#testi" data-slide-to="4"></li>
                                    <li data-target="#testi" data-slide-to="5"></li>
                                    <li data-target="#testi" data-slide-to="6"></li>
                                    <li data-target="#testi" data-slide-to="7"></li>
                                    <li data-target="#testi" data-slide-to="8"></li>
                                    <li data-target="#testi" data-slide-to="9"></li>
                                    <li data-target="#testi" data-slide-to="10"></li>
                                    <li data-target="#testi" data-slide-to="11"></li>
                                    <li data-target="#testi" data-slide-to="12"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/James-Smith.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">이전에 경험할 수 없었던 영문법 교정 AI 툴이네요. 특히 중요한 문법 규칙과 단어 수까지 감수해 줘서 많은 도움을 받았습니다.
                                                    </p>
                                                    <p class="authorNameText">제임스 스미스</p>
                                                    <span class="authorDesignationText">학술 에디터, 미국</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">영어가 모국어가 아닌 저자들이 올바른 영어 문법과 문체로 글을 쓰는 것은 쉬운 일이 아닙니다. 때때로 저자들은 외부의 도움이 없이,
                                                        그리고 더 나아가 학문적인 글에서 작은 실수조차 발견하기 어려울 수 있습니다. 자동보정 툴로 트링카 AI를 사용해봤는데, 제안된
                                                        수정사항과 피드백에 상당히 만족했습니다. 피드백을 통해 제안된 변경사항을 자세하고 간편하게 알려줘서 좋습니다.</p>
                                                    <p class="authorNameText">로사 디아즈 산도발</p>
                                                    <span class="authorDesignationText">물리학 및 수학 박사, 멕시코</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">저는 주로 국내외 생물의학저널에 기고하는 과학원고의 언어, 문법, 구문 개선을 위해 트링카를 사용해 왔습니다. 인터페이스가 사용자
                                                        친화적이고 사용방법이 간단해서 매우 효율적이고 번거롭지 않아 좋습니다. 논문을 편집할 수 있는 여러 가지 옵션을 필요에 따라
                                                        사용하면서, 제가 어떤 부분에 집중해야 하는지 결정할 수 있어 아주 좋습니다. 자동 수정은 논문 작성에 큰 도움이 되고, 수정
                                                        요약을 한눈에 볼 수 있는 요약 페이지는 훌륭한 아이디어네요. </p>
                                                    <p class="authorNameText">파룩 라토어 박사</p>
                                                    <span class="authorDesignationText">조교수 및 학과장, 파키스탄</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Georgieva-Milena.jpg" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka.ai는 문법과 맞춤법 수정을 위해 제가 가장 유용하게 사용하고 있는 도구입니다. 애플리케이션이 최적화 되어있어 잘 작동하고
                                                        빠르고 깔끔합니다! 대만족!</p>
                                                    <p class="authorNameText">밀레나 게오르기예바</p>
                                                    <span class="authorDesignationText">연구원</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">타제품에서 검사했던 문서를 다시 트링카에서 재확인했는데, 타제품보다 더 정확한 문법 체크를 하는 것 같아요. 놀랍네요!</p>
                                                    <p class="authorNameText">디네시 굽타</p>
                                                    <span class="authorDesignationText">방사선사, 인도</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Edith-Davies.jpg" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">저는 트링카를 테스트 해봤고, 훌륭한 기능에 감명받았습니다. 기존에 사용하던 문법 검사툴보다 더 좋은것 같다는 느낌을 받았습니다.
                                                        같은 연구실 동료들에게 트링카를 사용하라고 적극
                                                        <br>추천했고, 트링카가 학계에서 널리 사용되기를 바랍니다.</p>
                                                    <p class="authorNameText">에디스 데이비스</p>
                                                    <span class="authorDesignationText">박사학위자, 영국</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Noor-Al-rishi.png" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">트링카 AI가 제안한 수정사항과 피드백은 놀라울 정도로 유용합니다 . 사용이 간편하고 아주
                                                        <br>편리합니다.</p>
                                                    <p class="authorNameText">누르 알 리시</p>
                                                    <span class="authorDesignationText">화학자, 사우디 아라비아</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Nwaji-Jude.jpg" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">트링카를 사용한 것은 정말 좋은 경험이었고, 트링카를 사용하지 않고는 어떤 논문도 제출할 수 없습니다. 요약하자면, 트링카는 저의
                                                        생명을 구했어요!</p>
                                                    <p class="authorNameText">은와지 주드</p>
                                                    <span class="authorDesignationText">연구원</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">저는 트링카를 수정한 문서들의 최종 체크 도구로 아주 유용하게 사용하고 있습니다. 기본 수정 중에 발생하는 오류들을 쉽고 빠르게 찾는
                                                        데 큰 도움이 됩니다. 플랫폼이 정말 마음에 드네요.
                                                    </p>
                                                    <p class="authorNameText">스텀프 커티스</p>
                                                    <span class="authorDesignationText">연구원</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dyke-Gareth.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">저는 Trinka.ai이 특히 에디터/출판계 에디터/ 저널 에디터들에게 매우 흥미롭고 유용한 도구라고 생각합니다. 플랫폼에서 수정
                                                        작업을 실시간으로 빠르게 확인 할 수 있다는 점이 매우 유용했습니다.</p>
                                                    <p class="authorNameText">개러스 다이크</p>
                                                    <span class="authorDesignationText">연구원</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">저는 트랑카를 사용하고 나서 전체적인 결과물에 만족합니다. 오랫동안 그래멀리를 사용해 왔지만, 학문적 글쓰기나 기술적인 글쓰기에 있어서는
                                                        트링카가 훨씬 더 나은 선택인것 같습니다. 학술 논문 설정과 자동 파일 수정 기능이 아주 편리하고 유용합니다.</p>
                                                    <p class="authorNameText">바르가바 샤르마</p>
                                                    <span class="authorDesignationText">전염병학자, India</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Ralph-Bailey.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">트링카는 문법 교정을 위한 저만의 도구입니다. 인공지능을 기반으로 언어 교정과 언어 향상은 글쓰기를 훨씬 더 쉽게 만들어줍니다. 문법적으로
                                                        오류가 없는 문서를 작성하는 것에 노력하는 시간을 줄일 수 있었고, 덕분에 연구에 더 집중할 수 있게 되었습니다.</p>
                                                    <p class="authorNameText">랄프 베일리</p>
                                                    <span class="authorDesignationText">신경과 의사, USA</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Thomas-Andres.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">AMA 스타일 가이드에 근거한 문법 수정과 제안이 정말 인상적입니다! 트링카는 의학적인 글쓰기를 위한 최고의 문법 교정 도구입니다.
                                                    </p>
                                                    <p class="authorNameText">토마스 안드레스</p>
                                                    <span class="authorDesignationText">심장전문의, Brazil</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                </div>
                            </div>
                            <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#testi" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

    

<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>망설이지 말고 지금 사용해보세요.</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank" id="grammerSignUpButton">
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <span> 무료 가입 </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckQuestions">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="GCQuestions">
                    <h2>트링카 구두점 검사기 자주 하는 질문</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
                <div class="row">
                    <div class="offset-md-1 col-md-10">
                        <div class="answersSections">
                            <div class="accordion" id="QeustionGrammarChecks">
                                <div class="card">
                                    <div class="card-header" id="QuestionGCOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCOneContent" aria-expanded="true"
                                            aria-controls="QuestionGCOneContent">
                                            트링카 구두점 검사기는 작동 원리가 어떻게 되나요?</a>
                                    </div>
        
                                    <div id="QuestionGCOneContent" class="collapse show"
                                        aria-labelledby="QuestionGCOne" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>트링카의 구두점 검사 도구는 최신 기계학습(ML) 및 자연어(NPL) 기술을 통해 개발되어 구두점 오류를 쉽게 식별하고 개선 사항을 제안합니다. 트링카 AI는 사용자의 글이 문장 구조 내에서 구두점에 일관성을 갖도록 도와드립니다.</p>
                                        </div>
                                    </div>
                                </div>        
                                
                                <div class="card">
                                    <div class="card-header" id="QuestionGCTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCTwoContent" aria-expanded="true"
                                            aria-controls="QuestionGCTwoContent">트링카의 문법 및 구두점 검사기는 무료인가요?</a>
                                    </div>
        
                                    <div id="QuestionGCTwoContent" class="collapse"
                                        aria-labelledby="QuestionGCTwo" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>예, 트링카 베이직 서비스는 완전히 무료로 사용할 수 있습니다. 여기에서 <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">가입</a>하여 툴 사용을 시작할 수 있습니다. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCThreeContent" aria-expanded="true"
                                            aria-controls="QuestionGCThreeContent">트링카는 어떤 구두점 오류를 검사할 수 있나요?</a>
                                    </div>
        
                                    <div id="QuestionGCThreeContent" class="collapse"
                                        aria-labelledby="QuestionGCThree" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>트링카는 다음과 같은 구두점의 오류를 검사할 수 있습니다.</p>
                                            <ul>
                                                <li>쉼표(,)</li>
                                                <li>마침표(.)</li>
                                                <li>하이픈(-)</li>
                                                <li>세미콜론(;)</li>
                                                <li>콜론(:)</li>
                                                <li>물음표(?)</li>
                                                <li>엠 대시(—)</li>
                                                <li>엔 대시(–)</li>
                                                <li>아포스트로피(‘)</li>
                                                <li>줄임표(…)</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="card">
                                    <div class="card-header" id="QuestionGCFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFourContent" aria-expanded="true"
                                            aria-controls="QuestionGCFourContent">다른 웹사이트에서도 구두점 검사를 할 수 있나요?</a>
                                    </div>
        
                                    <div id="QuestionGCFourContent" class="collapse"
                                        aria-labelledby="QuestionGCFour" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>예. Chrome, Firefox 또는 Edge용 <a  [routerLink]="['/browser-plugin']">브라우저 플러그인</a>을 설치하기만 하면 트링카의 마법을 즐길 수 있습니다.</p>
                                        </div>
                                    </div>
                                </div>

                                
        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>




<!-- Modal -->
<div class="modal fade" id="usageLimitExhausted" tabindex="-1" role="dialog" aria-labelledby="usageLimitExhaustedLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" id="closedExceededPopup" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="upgradePremiumSection">
            <div class="upgradeHeaderSection">
               <div class="upgradeHeaderSection_overlay"></div>
               <h4>앗! 콘텐츠 제한을 초과했습니다.</h4>
            </div>
            <div class="upgradeBodySection">
               <!-- <h2>Sign Up for free and get 5000 words/month</h2> -->
               <p style="margin: 0; margin-top: 10px;">무료 트링카 계정에서는 매달 최대 5000단어까지 글을 확인할 수 있습니다.</p>
               <!-- <p> All you need to do is Sign Up for free.</p> -->
               <div class="goupgradeButton">
                <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">무료 가입하기</a>
                <button id="FooterClosedExceededPopup">편집기로 돌아가기</button>
               </div>
            </div>
         </div>
      </div>
    </div>
</div>
    <!--Modal for accept limit exceeded-->
<div class="modal fade" id="acceptedLimitExhausted" tabindex="-1" role="dialog" aria-labelledby="acceptedLimitExhaustedLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <button type="button" id="closedAcceptedLimitExhaustedPopup"   (click)="hideModal2()" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
             <div class="limitExhaustedBody">
                 <div class="limitExhaustedLeftContent">
                     <div class="logoSection">
                         <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                     </div>
                     <div class="ExhaustedLeftContent">
                         <h2>더 많은 문법 수정 및 원클릭 편집.</h2>
                         <a href="https://cloud.trinka.ai/signup?_rg=Punctuation-Checker-JS-KR" target="_blank">무료 계정 받기</a>
                     </div>
                 </div>
                 <div class="limitExhaustedRightContent">
                     <div class="rightInnerContent">
                         <img class="backgourndImageSection" src="../../../assets/images/home_banner.jpg" alt="banner">
                         <div class="imagesOverlaySection"></div>
                     </div>
                     <div class="ExhastedRightContainer">
                        <img src="../../../assets/images/PerfectPunctuationCheck.png" class="grammarCheckCardImg" alt="card" >
                        <img src="../../../assets/images/WorksOnAllSubjects.png" class="EnhanmentCheckCardImg" alt="card" >
                        <a href="https://cloud.trinka.ai/signup?_rg=Punctuation-Checker-JS-KR" target="_blank">무료 계정 받기</a>
                    </div>
                 </div>
             </div>
    
          </div>
        </div>
      </div>